module.exports = __webpack_public_path__ + "static/media/video-editor-new.f83f5dcf.mov";